var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7257 12.5587L8.60898 10.467L8.63398 10.442C10.084 8.82533 11.1173 6.96699 11.7257 5.00033H14.1673V3.33366H8.33398V1.66699H6.66732V3.33366H0.833984V4.99199H10.1423C9.58398 6.60033 8.70065 8.12533 7.50065 9.45866C6.72565 8.60033 6.08398 7.65866 5.57565 6.66699H3.90898C4.51732 8.02533 5.35065 9.30866 6.39232 10.467L2.15065 14.6503L3.33398 15.8337L7.50065 11.667L10.0923 14.2587L10.7257 12.5587ZM15.4173 8.33366H13.7507L10.0007 18.3337H11.6673L12.6007 15.8337H16.559L17.5007 18.3337H19.1673L15.4173 8.33366ZM13.234 14.167L14.584 10.5587L15.934 14.167H13.234Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.b3550994deac588bf9dcc9b30f8988bd.svg";
export { ForwardRef as ReactComponent };